module.exports = __webpack_public_path__ + "img/empty-offer-1.d088f272.png";